import isNull from 'lodash/isNull';

const iOSBounceMargins = {
  // bigger margin on right
  // to prevent stuck on iOS
  marginRight: 125,
  marginLeft: 25,
  marginTop: 25,
  marginBottom: 25
};

export function hasTouchedBoundings(x, y, bounds, margins = iOSBounceMargins) {
  const { left, top, right, bottom } = bounds;
  const { marginLeft, marginTop, marginRight, marginBottom } = { ...iOSBounceMargins, ...margins };

  if (!isNull(marginLeft) && x - left <= marginLeft) return true;
  if (!isNull(marginRight) && right - x <= marginRight) return true;
  if (!isNull(marginBottom) && bottom - y <= marginBottom) return true;
  if (!isNull(marginTop) && y - top <= marginTop) return true;
  return false;
}

export function getActivityBoundings() {
  const container = document.querySelector('.activity-wrapper');
  const boundRect = container.getBoundingClientRect();
  return {
    left: boundRect.left,
    top: boundRect.top,
    right: boundRect.left + boundRect.width,
    bottom: boundRect.top + boundRect.height
  };
}

export function hasCollided(el, parent, step) {
  const elBounds = el.getBoundingClientRect();
  const parentBounds = parent.getBoundingClientRect();
  const left = elBounds.left - step < parentBounds.left;
  const right = elBounds.right + step > parentBounds.right;
  const top = elBounds.top - step < parentBounds.top;
  const bottom = elBounds.bottom + step > parentBounds.bottom;

  return {
    left,
    right,
    top,
    bottom
  };
}

export function getCharacterAmountInSteps(steps) {
  return steps.reduce((acc, { answer }) => acc + answer.length, 0);
}
